<template lang="html">

  <div class="timeline" v-bind:id="id" >
    <div v-for="(event, i) in events" v-bind:key="event && event.id ? event.id : i" v-bind:class="{'timeline-item':event.type=='item','timeline-header':event.type=='header'}">

      <span v-if="event.type=='header'" class="tag is-primary">{{ event.subject }}</span>

      <div v-if="event.type=='item'" class="timeline-marker" v-bind:class="{'is-icon':event.icon}">
        <i class="fa" v-bind:class="'fa-'+event.icon"></i>
      </div>

      <div v-if="event.type=='item'" class="timeline-content">
        <!-- <p class="heading">{{ event.date }}</p> -->
        <p class="heading">{{ formatDate( event.date ) }}{{ event.priority?' - '+event.priority:'' }}</p>
        <a href="#" v-on:click.prevent="select(event)">
          <!-- {{ event.activity }}{{ event.subject?' - '+event.subject:'' }} -->
          {{ event.subject }}{{ event.status?' - '+event.status:'' }}
        </a>
      </div>

    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'bulmaTimeline',
  components: {
  },
  computed: {
//     config: function() {
//       return '';
// //      return this.$store.getters.getObject(this.id).data;
//     },
    process() {
      return this.$store.getters.getObject(this.id).data.lookup_process;
    },
    events() {
      console.log("this.records: ", this.records)
      var eventi = []
      if(this.records) {
        this.records.forEach( r => {
          // SOLO TASK
          let event;
          if (!r.Type) {
            r.Type = "";
            event=this.setTaskEvent(r);
            
          }
          if (r.Type=='Task') event=this.setTaskEvent(r);
          if (r.Type=='Note') event=this.setNoteEvent(r);
          if (r.Type=='Meeting') event=this.setCalendarEvent(r);

          if(r.type!="Notification" && r.type!="NotificationArchived" && event) eventi.push(event);
        })
      }
      return eventi
    },

  },
  props: {
    id: String,
    // events: Array
    records: Array,
    config: Object
  },
  data() {
    return {
    }
  },
  mounted: function() {
  },
  async created() {
  },
  methods: {
    setTaskEvent(r) {
      let event={
        type:'item',
        activity:'Task',
        icon:'tasks',
        subject: r["Subject"],
        id: r.Id,
        status: r["Status"],
        priority: r["Priority"],
      };
      if (r["ActivityDate"]) 
        event.date=r["ActivityDate"];
      else
        event.date=r["CreatedDate"];

      return event;
    },
    setNoteEvent(r) {
      let event={
        type:'item',
        activity:'Note',
        icon:'sticky-note',
        subject: r["Subject"],
        id: r.Id
      };
      if (r["ActivityDate"]) event.date=r["ActivityDate"];
      else event.date=r["CreatedDate"];
      return event;
    },
    setCalendarEvent(r) {
      let event={
        type:'item',
        activity:'Event',
        icon:'calendar',
        subject: r["Subject"],
        id: r.Id
      };
      if (r["StartDateTime"]) event.date=r["StartDateTime"];
      else event.date=r["CreatedDate"];
      return event;
    },
    select(event) {
      console.log('--> select', event);
      var record = {}
      this.records.forEach(r => {
        if(r.Id == event.id) record = r
      })
      console.log('record: ', record)
      delete record.show
      let data
      if(event.activity=="Task"){
        data = {
          processId: this.process,
          verbId: "ePopup",
          title: event.subject,
          table: this.config.table
        }
        console.log('data',data)
      }else if(event.activity=="Note"){
        data =  {
          processId: this.process,
          verbId: "en",
          title: event.subject,
          table: this.config.table
        }
        console.log('data note',data)
      }else{
        data =  {
          processId: this.config.lookup_process_calendar,
          verbId: "e",
          title: event.subject,
          table: event.activity
        }
      }
      data['candelete'] = this.enableDelete(record)
      
      this.$store.commit('PUSH_PROCESS_STATUS', data);
      // this.$store.commit('SET_RECORDS_STATE', {id: this.process, state:'EDIT'});
      const correctProcess = event.activity == 'Event' ? this.config.lookup_process_calendar : this.process;
      this.$store.commit('SET_RECORDS_STATE', {id: correctProcess, state:this.setState(record)});
      this.$store.commit('SET_RECORDS_DATA', {id: correctProcess, data: record });
    },
    formatDate(date) {
      var d=new moment(date);
      return d.format('DD/MM/YYYY');
    },
    enableDelete(record) {
      if(this.config.candelete) {
        if(!record.TaskSubtype) return true
        // non possono eliminare i task creati dall'invio di email
        if(record.TaskSubtype && record.TaskSubtype == 'Email') return false
        return true
      }
      return false
    },
    setState(record) {
      if(record.Type == 'Meeting' || !record.TaskSubtype) return 'EDIT'
      // non possono modificare i task creati dall'invio di email
      if(record.TaskSubtype && record.TaskSubtype == 'Email') return 'READY'
      return 'EDIT'
    }
  }
}
</script>

<style scoped>
</style>
